import { combineReducers } from 'redux';

import errors from './errors';
import pages from './pages';
import pagesContent from './pagesContent';

import {
  ACTION_LOAD_SITE_STATIC_PAGES__REQUEST,
  ACTION_LOAD_SITE_STATIC_PAGES__FAIL,

  ACTION_SET_SITE_FOOTER_LINKS_PAGES_SORTED_IDS,
  ACTION_SET_SITE_FOOTER_LINKS_LANGS,
  ACTION_SET_SITE_FOOTER_LINKS_MAX_PAGES,
} from '../actionTypes';


const sortedPagesIds = (state = [], action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_STATIC_PAGES__REQUEST:
    case ACTION_LOAD_SITE_STATIC_PAGES__FAIL:
      return [];


    case ACTION_SET_SITE_FOOTER_LINKS_PAGES_SORTED_IDS:
      return action.payload.siteFooterLinksPagesIds;

    default:
      return state;
  }
};

const langs = (state = [], action) => {
  switch (action.type) {
    case ACTION_SET_SITE_FOOTER_LINKS_LANGS:
      return action.payload.langs;

    default:
      return state;
  }
};

const maxPages = (state = null, action) => {
  switch (action.type) {
    case ACTION_SET_SITE_FOOTER_LINKS_MAX_PAGES:
      return action.payload.maxPages;

    default:
      return state;
  }
};

export default combineReducers({
  errors,
  langs,
  maxPages,
  pages,
  pagesContent,
  sortedPagesIds,
});
